import React from 'react';
import { FlatList, View } from 'react-native';
import { rem } from 'design-system';
import ListEmptyView from 'design-system/ListEmptyView';
import FlatListItemCard from 'design-system/FlatListItemCard';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import ClaimRewardsRow from 'features/rewards/components/ClaimRewardsRow';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { isWeb } from '../../../constants';
const pending = 'Cashback waiting to be paid will show here. It can take up to two weeks for a purchase to appear in this section.';
const available = 'Cashback ready to be claimed will show here. This can take up to 60 days and varies for different rewards.';
const ClaimRewardsSection = ({ data, tabLabel, }) => {
    const styles = useStyles(styleSet);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    if (!data)
        return null;
    const { rewards } = data;
    return (<FlatList contentContainerStyle={[styles.contentWithList, paddingHorizontalStyle]} ListEmptyComponent={() => {
            const textToDisplay = tabLabel === 'Pending' ? pending : available;
            return (<View style={styles.emptyPlaceholder}>
            <ListEmptyView compact onCard title={tabLabel === 'Pending'
                    ? 'Cashback waiting to be paid will show here'
                    : 'Cashback ready to be claimed will show here'} subTitle={textToDisplay}/>
          </View>);
        }} renderItem={({ item, index }) => (<FlatListItemCard index={index} itemsLength={rewards.length} style={styles.card}>
          <ClaimRewardsRow key={item.id} item={item} isPending={tabLabel === 'Pending'}/>
        </FlatListItemCard>)} data={rewards}/>);
};
const styleSet = createStyleSheets((colors) => ({
    content: {
        margin: rem(16),
    },
    contentWithList: {
        flex: 1,
        marginTop: rem(16),
    },
    card: {
        backgroundColor: colors.cards.onDark,
    },
    emptyPlaceholder: {
        flexDirection: 'row',
    },
}));
export default React.memo(ClaimRewardsSection);
